import { render, staticRenderFns } from "./EditRefinement.vue?vue&type=template&id=016c2fb4&"
import script from "./EditRefinement.vue?vue&type=script&lang=js&"
export * from "./EditRefinement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports